module.exports = __webpack_public_path__ + "static/img/welcome@2x.ff195757.png";